import React, { useCallback } from "react";
import { Combobox, type ComboboxItem, Input } from "@bloomberg/media.atomics";

import DefaultListCheckbox from "./DefaultListCheckbox";
import styles from "./styles.module.css";
import { CURRENCY_DROPDOWN_OPTIONS } from "~data/watchlist/currencies";

const currencyItems: ComboboxItem[] = CURRENCY_DROPDOWN_OPTIONS.map(
  (option) => ({
    value: option.value,
    label: option.displayName,
  })
);

type WatchlistMetadataProps = {
  readonly name: string;
  readonly currency: string;
  readonly isDefault: boolean;
  readonly onNameChange: (value: string) => void;
  readonly onCurrencyChange: (value: string) => void;
  readonly onDefaultChange: (checked: boolean) => void;
};

export default function WatchlistMetadata({
  name,
  currency,
  isDefault,
  onNameChange,
  onCurrencyChange,
  onDefaultChange,
}: WatchlistMetadataProps) {
  const handleCurrencyChange = useCallback(
    (value: string | null) => {
      if (value) onCurrencyChange(value);
    },
    [onCurrencyChange]
  );

  return (
    <div className={styles.metadata}>
      <div className={styles.metadataName}>
        <Input
          labelText="Watchlist Name"
          size="large"
          value={name}
          onChange={onNameChange}
        />
      </div>
      <div className={styles.metadataCurrency}>
        <Combobox
          labelText="Currency"
          items={currencyItems}
          value={currency}
          onValueChange={handleCurrencyChange}
        />
      </div>
      <DefaultListCheckbox checked={isDefault} onChange={onDefaultChange} />
    </div>
  );
}
